import React from 'react';

const ChangeInfo = () => {
    return (
        <div>
            change info
        </div>
    );
}

export default ChangeInfo;
